import { useState, useMemo } from 'react';
import * as d3 from 'd3';

import './ScatterPlot.css';

import { Axes } from '../Axes/Axes';
import { Tooltip } from '../Tooltip/Tooltip';

const BUBBLE_MIN_SIZE = 3;
const BUBBLE_MAX_SIZE = 9;

export const ScatterPlot = ({
  width,
  height,
  data,
  initialData,
  handleMediaClick,
}) => {
  const [interactionData, setInteractionData] = useState();

  // Sort the data: bigger circles must appear at the bottom
  const sortedData = data.sort((a, b) => b.size - a.size);

  // Scales
  const xScale = d3.scaleLinear().domain([-1, 1]).range([0, width]);
  const yScale = d3.scaleLinear().domain([-1, 1]).range([height, 0]);
  const sizeScale = useMemo(() => {
    const [min, max] = d3.extent(initialData.map((d) => d.size));
    return d3
      .scaleSqrt()
      .domain([min, max])
      .range([BUBBLE_MIN_SIZE, BUBBLE_MAX_SIZE]);
  }, [data]);

  // All circles, 1 per article
  const circles = sortedData.map((d, i) => {
    const size = sizeScale(d.size);

    const xPos = xScale(d.x) - size / 2;
    const yPos = yScale(d.y) - size / 2;

    const isDimmed = interactionData && interactionData.color !== d.color;
    const className = isDimmed
      ? 'scatterPlot-circle dimmed'
      : 'scatterPlot-circle';

    return (
      <g
        key={'g-' + i}
        onMouseMove={() =>
          setInteractionData({
            xPos,
            yPos,
            ...d,
          })
        }
        onMouseLeave={() => setInteractionData(undefined)}
        onClick={() => handleMediaClick(d)}
      >
        <circle
          key={'circle-' + i}
          r={sizeScale(d.size)}
          cx={xScale(d.x) + 10}
          cy={yScale(d.y) + 10}
          opacity={1}
          stroke='black'
          fill={d.color}
          fillOpacity={1}
          strokeWidth={1}
          className={className}
        />
      </g>
    );
  });

  return (
    <div className='scatterPlot-container'>
      <svg width={width + 20} height={height + 20}>
        <g>
          <Axes width={width} height={height} />
          {circles}
        </g>
      </svg>
      <Tooltip interactionData={interactionData} />
    </div>
  );
};
